import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AccountFormOptions, ForgotPassword, StiiraError } from '@core/models';
import { AccountService, ConstantsService, ErrorService, HeaderService, SnackbarService } from '@core/services';
import { AccountPagesSystemTextService } from '@core/services/account-pages-system-text.service';
import { FormGroup } from '@angular/forms';
import { indicate } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';
import { pluck, tap } from 'rxjs/operators';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  static readonly componentName = 'ForgotPasswordComponent';
  
  isSubmitting$ = new Subject<boolean>();
  options: AccountFormOptions;
  successNotificationText: string;
  sysText$: Observable<any>;
  templateName: string;

  constructor(
    private acctService: AccountService,
    private acctTextService: AccountPagesSystemTextService,
    private constants: ConstantsService,
    private snackbarService: SnackbarService,
    private errorService: ErrorService,
    private router: Router,
    private headerService: HeaderService  ) {}

  ngOnInit() {
    this.templateName = this.acctTextService.templates.forgotPassword;
    this.sysText$ = this.acctTextService.sysText$.pipe(
      pluck(this.templateName),
      tap((res) => (this.successNotificationText = res[`${this.templateName}_successNotification`])),
      tap((res) => this.headerService.setPageTitle(res[`${this.templateName}_accountForm_title`]))
    );
    this.options = this.constants.ACCOUNTFORM_OPTIONS_FORGOTPASSWORD;
  }

  onFormSubmit(form: FormGroup): void {
    const forgotPasswordModel: ForgotPassword = {
      username: form.value.username,
    };

    this.acctService.forgotPassword(forgotPasswordModel)
      .pipe(indicate(this.isSubmitting$))
      .subscribe(() => {
        this.handleSuccess();
      },(err: StiiraError) => {
        this.errorService.setFormModelStateErrors(form, err.modelStateErrors);
      }
    );
  }

  private handleSuccess(): void {
    const successText: string = this.successNotificationText;
    this.snackbarService.open(successText, '', 5000);
    this.router.navigate(['/login']);
  }
}